(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventDashboardController', EventDashboardController);

    EventDashboardController.$inject = ['$state', 'EventDashboard', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'EventConfigurationAssistant'];

    function EventDashboardController($state, EventDashboard, ParseLinks, AlertService, pagingParams, paginationConstants, EventConfigurationAssistant) {
        var vm = this;
        vm.openAssistant = function() { EventConfigurationAssistant.open('DASHBOARD', loadAll); };
        EventConfigurationAssistant.canUse('DASHBOARD').then(function(allowed) { vm.canUseAssistant = allowed; });

        vm.dashboards = [];
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.inclInactive = false;

        loadAll();

        function loadAll() {
            EventDashboard.query({
                inclInactive: vm.inclInactive,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dashboards = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }
    }
})();
